<div *ngIf="shouldShowButton()" class="stop-button-section">
  <ion-button 
    color="danger" 
    expand="block" 
    (click)="stopFiring()"
    [disabled]="stoppingFiring || !isPairedToMe">
    <ion-icon name="stop-circle-outline" slot="start"></ion-icon>
    {{ stoppingFiring ? ('KILN_STATUS.STOPPING_FIRING' | translate) : ('KILN_STATUS.STOP_FIRING' | translate) }}
  </ion-button>
  <p *ngIf="!isPairedToMe && !stoppingFiring" class="pairing-message">
    {{ 'KILN_STATUS.STOP_FIRING_NOT_PAIRED' | translate }}
  </p>
</div> 